import React, { useCallback, useEffect, useState } from "react";
import { amApi } from "../../../../api/apiHelper";
import { errorAlert } from "../../../../function/alert";
import Debounce from "../../../../function/debounce";
import { TextField, List, ListItem, Divider } from "@material-ui/core";
import { Form } from "react-bootstrap";
import Autocomplete from "@material-ui/lab/Autocomplete";

export default function SearchByRestaurant({
  onChangeRestaurant,
  setrestdata,
  edit,
  restaurant,
}) {
  const [rest, setRest] = useState({ restaurant_name: "" });

  const [rests, setRests] = useState([]);

  useEffect(() => {
    if (edit) {
      setRest({
        ...restaurant,
        restaurant_name: restaurant?.name,
        restaurant_address: restaurant?.address,
      });
      setRests([
        {
          ...restaurant,
          restaurant_name: restaurant?.name,
          restaurant_address: restaurant?.address,
        },
      ]); // Set the default data in the rests state
    }
  }, [edit, restaurant]);

  const onChange = async (value) => {
    try {
      if (value) {
        if (value?.length >= 3) {
          let data = await amApi.get(`/searchRestaurant?name=${value}`);
          data = data.data;
          setRests(data);
        } else {
          errorAlert("Please enter atleast 3 letters of the restaurant name");
        }
      }
    } catch (err) {
      errorAlert("Something went wrong, try again later");
    }
  };
  const debounceOnChange = useCallback(Debounce(onChange, 1000), []);

  const onRestSelect = (data) => {
    setRests([]);
    setRest({
      restaurant_name: data?.restaurant_name,
      restaurant_id: data?._id,
    });

    if (onChangeRestaurant) {
      onChangeRestaurant(data._id);
    }

    if (setrestdata) {
      setrestdata(data);
    }
  };
  return (
    <div>
      <Form.Group className="mb-0 auto-complete">
        <div className="f16-700 mr-2 my-2">Search Restaurant</div>
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          options={rests}
          size="medium"
          getOptionLabel={(_rest) => {
            console.log(_rest);
            if (_rest?.restaurant_name || _rest?.restaurant_address)
              return `${_rest?.restaurant_name?.toString() || ""} , ${
                _rest?.restaurant_address?.toString() || ""
              }`;
            else return "";
          }}
          onChange={(e, v) => {
            onRestSelect(v);
          }}
          defaultValue={restaurant}
          sx={{ width: 300 }}
          renderOption={(props, _rest) => {
            console.log(props, _rest);
            return (
              <p {...props}>
                <img
                  src={props?.logo_url}
                  alt={_rest.restaurant_name}
                  style={{ width: "24px", height: "24px", marginRight: "8px" }}
                />
                {props?.restaurant_name?.toString()} ,{" "}
                {props?.restaurant_address?.toString()}
              </p>
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Search Restaurant"
              onChange={(e) => {
                setRest({ restaurant_name: e.target.value });
                debounceOnChange(e.target.value);
              }}
            />
          )}
        />
        {/* <TextField
          id="restaurant_id"
          label="Search Restaurant"
          type="text"
          variant="outlined"
          className={`w-100`}
          name="restaurant_id"
          value={rest?.restaurant_name}
          onChange={(e) => {
            setRest({ restaurant_name: e.target.value });
            debounceOnChange(e.target.value);
          }}
        /> */}
      </Form.Group>

      {/* {rests?.length ? (
        <>
          <div className="position-absolute bottom-0 w-100 mh-20">
            <List
              dense
              className="w-100"
              style={{ zIndex: 999, backgroundColor: "#ffffff" }}
            >
              {rests.length ? (
                rests.map((rest) => (
                  <>
                    <ListItem
                      className="p-2 cursor-pointer"
                      onClick={(e) => onRestSelect(rest)}
                    >
                      {rest.restaurant_name}
                    </ListItem>
                    <Divider />
                  </>
                ))
              ) : (
                <></>
              )}
            </List>
          </div>
        </>
      ) : null} */}
    </div>
  );
}
